import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SmsService } from '../../../services/sms.service';
import { creditsTypeIcon } from '../../../utils/constants';

let startingId = 0;

@Component({
  selector: 'wsb-ui-radio-credit-types',
  templateUrl: './radio-credit-types.component.html',
  styleUrls: ['./radio-credit-types.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioCreditTypesComponent)
    }
  ],
  standalone: false
})
export class RadioCreditTypesComponent implements OnInit, ControlValueAccessor {
  @Input() showLabel = true;
  @Input() showAdv = true;
  @Input() creditType: string | null;
  @Output() creditTypeChange = new EventEmitter();
  @Output() creditTypesChange = new EventEmitter();
  randomId = startingId++;

  credits: any[] = [];

  propagateChange(newCreditType: any) {
    this.creditTypeChange.emit(newCreditType);
  }

  constructor(private smsService: SmsService) {}

  ngOnInit() {
    if (this.showAdv) {
      this.smsService.getMessageTypes().subscribe(data => {
        this.credits = data.data.map(x => {
          return {
            value: x.id,
            icon: creditsTypeIcon[x.id],
            title: x.label
          };
        });
      });
    } else {
      this.smsService.getMessageTypes().subscribe(data => {
        this.credits = data.data
          .filter(type => type.id !== 'AD')
          .map(x => {
            return {
              value: x.id,
              icon: creditsTypeIcon[x.id],
              title: x.label
            };
          });
      });
    }
    setTimeout(() => {
      this.creditTypeChange.emit(this.creditType);
      if (this.credits.length) {
        this.creditTypesChange.emit(this.credits);
      }
    });
  }

  emitCreditType(newCreditType) {
    this.propagateChange(newCreditType);
  }

  onChange(checked) {
    this.propagateChange(checked);
  }

  writeValue(obj: any): void {
    this.creditType = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}
}
